import React, { useEffect } from 'react';
import TutorialModal from './TutorialModal';
import { useTutorial } from './TutorialProvider';
import { useAuth } from '../auth/AuthContext';

const TutorialManager = () => {
    const { currentUser, studentModels } = useAuth();
    const {
        isActive,
        getCurrentStepData,
        startTutorial,
        endTutorial
    } = useTutorial();

    // Start tutorial automatically for new students only
    useEffect(() => {
        // Only proceed if we have a student user and their models have loaded
        if (currentUser?.role === 'student' && studentModels) {
            // Check if they have created any links in any model
            const hasCreatedLinks = Object.values(studentModels).some(model =>
                model.links && model.links.length > 0
            );
            // Start tutorial only for students who haven't created any links
            if (!hasCreatedLinks) {
                startTutorial();
            }
        }
    }, [currentUser, startTutorial, studentModels]);

    const currentStep = getCurrentStepData();

    // When tutorial ends, mark it as completed
    const handleClose = () => {
        localStorage.setItem('tutorialCompleted', 'true');
        endTutorial();
    };

    // Don't render anything for non-students or if tutorial is not active
    if (currentUser?.role !== 'student' || !isActive || !currentStep) {
        return null;
    }

    // Replace placeholder with actual user name if available
    const messageText = currentUser?.firstName
        ? currentStep.text.replace('<firstname>', currentUser.firstName)
        : currentStep.text.replace('<firstname>', '');

    return (
        <TutorialModal
            isOpen={isActive}
            onClose={handleClose}
            message={messageText}
            position={{
                bottom: '20%',
                left: '50%',
                transform: 'translateX(-50%)'
            }}
        />
    );
};

export default TutorialManager;